import { FC } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

interface IProps {
  width?: string;
  height?: string;
  color?: string;
}

export const Divider: FC<IProps> = ({
  width = "100%",
  height = "1px",
  color = withVar(DesignToken.BorderBasicSecondary),
}) => <Flex width={width} height={height} bg={color} />;
